import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  const acessType = localStorage.getItem("acessType");
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">


            {acessType === 'adm' ? <>
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-home"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/dashboard">
                    {props.t("Monitoramento")}
                    </Link>
                </li>
                <li>
                  <Link to="/maps">
                    {props.t("Mapa")}{" "}
                  </Link>
                </li>
                <li>
                  <Link to="/monitorar">
                    {props.t("Monitoramento de Serviços")}{" "}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-marker"></i>
                <span>{props.t("Cadastro")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <span>{props.t("Configuração")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="true">
                    <li>
                      <Link to="/cadastro/Payload">{props.t("Payloads")} </Link>
                    </li>
                    <li>
                      <Link to="/cadastro/acoesequipamento">
                        {props.t("Ações Equipamento")}{" "}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <span>{props.t("Módulos Lora")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="true">
                    <li>
                      <Link to="/cadastro/FabricanteLora">
                        {props.t("Fabricante Lora")}{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/cadastro/EquipamentoLora">
                        {props.t("Equipamento Lora")}{" "}
                      </Link>
                    </li>

                  </ul>
                </li>
                <li>
                  <Link to="/cadastro/hidrometro">{props.t("Hidrometro")}</Link>
                </li>
                <li>
                  <Link to="/cadastro/EquipamentoDmae">
                    {props.t("Equipamento DMAE")}{" "}
                  </Link>
                </li>
              {/*  <li>
                  <Link to="/logs">
                    {props.t("Logs - Alarmes")}{" "}
                  </Link>
                </li>*/}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-dashboard"></i>
                <span>{props.t("Consumos")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/consumo">{props.t("Consumo Macro")}</Link>
                </li>
                <li>
                  <Link to="/consumocondomino">{props.t("Consumo Condominio")}</Link>
                </li>
                <li>
                  <Link to="/consumoempresa">{props.t("Consumo Empresas")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/calibragem" className="waves-effect">
                <i className="ti-hummer"></i>
                <span>{props.t("Calibragem")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-notepad"></i>
                <span>{props.t("Usuário x empresa")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/usuarioempresa/cadastro">{props.t("Cadastrar")}</Link>
                </li>
                <li>
                  <Link to="/usuarioempresa/listar">
                    {props.t("Usuários e Empresas")}{" "}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/gestao-dados" className="waves-effect">
                <i className="ti-settings"></i>
                <span>{props.t("Gestão de dados")}</span>
              </Link>
            </li>
            <li>
              <Link to="/acesso-externo" className="waves-effect">
                <i className="ti-user"></i>
                <span>{props.t("Acesso externo")}</span>
              </Link>
            </li>
            </>
            :
            <>
              <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-home"></i>
                <span>{props.t("Consumo")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/externo">{props.t("Meu consumo")}</Link>
                </li>                
              </ul>
            </li>
            
            </>
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
